import clsx from 'clsx';

const STYLES = {
  draft: 'bg-slate-200 text-slate-700',
  published: 'bg-blue-100 text-blue-700',
  completed: 'bg-green-100 text-green-700',
  inactive: 'bg-red-100 text-red-600',
};

const LABELS = {
  draft: 'Draft',
  published: 'Out for signature',
  completed: 'Completed',
  inactive: 'Voided',
};

export default function StatusBadge({ status }) {
  return (
    <span
      className={clsx(
        'inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-semibold',
        STYLES[status] ?? STYLES.draft,
      )}
    >
      {LABELS[status] ?? status}
    </span>
  );
}
